<div class="box-wrapper">
    <app-link
        class="collection-box gtm-collection-box selenium-collection-box"
        [attr.data-gtmlabel]="collection.title"
        [appRouterLink]="collection.getRouterLink()"
    >
        <div class="title">{{ collection.title }}</div>
        <div
            *ngIf="posterImage1"
            class="poster-image-1"
            [ngStyle]="{
                background:
                    'url(\'' +
                    posterImage1 +
                    '\') top left / contain, url(\'' +
                    placeholderImage +
                    '\') top left / contain',
            }"
        ></div>
        <div
            *ngIf="posterImage2"
            class="poster-image-2"
            [ngClass]="{ stickLeft: !posterImage1 }"
            [ngStyle]="{
                background:
                    'url(\'' +
                    posterImage2 +
                    '\') top left / contain, url(\'' +
                    placeholderImage +
                    '\') top left / contain',
            }"
        ></div>
        <div
            *ngIf="posterImage3"
            class="poster-image-3"
            [ngClass]="{
                moveLeft: !posterImage1 && posterImage2,
                stickLeft: !posterImage1 && !posterImage2,
            }"
            [ngStyle]="{
                background:
                    'url(\'' +
                    posterImage3 +
                    '\') top left / contain, url(\'' +
                    placeholderImage +
                    '\') top left / 69%',
            }"
        ></div>
        <div class="poster-image-overlay"></div>
    </app-link>
    <div class="media-type selenium-card-media-type">
        <span>{{ collection.mediaTypesDisplay }} {{ collection.resourceByLanguage }}</span>
    </div>
</div>
